import 'slick-carousel/slick/slick.css';
import 'slick-carousel';

import './sass/index.scss';
import './js/_lightbox';
import './js/_faq';
import './js/_accordion';
import './js/_hero';
import './js/_content-slider';
import './js/_related-containers';
import './js/_related-posts';
import './js/_gallery-slider';
import './js/_nav';
